import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { environment } from '@envs/environment'
import { AuthService } from '@core/service/auth.service'
import { User } from '@core/model/user.model'
import { HeaderStyleService } from '@shared/services/header-style.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Title } from '@angular/platform-browser'
import _ from 'lodash'

@Component({
  selector: 'dashboard-overview',
  templateUrl: './dashboard-overview.component.html',
  styleUrls: ['./dashboard-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardOverviewComponent implements OnInit {
  baseJsUrl: string
  loggedInUser!: User
  tab: string

  constructor(
    private headerStyleService: HeaderStyleService,
    private envService: EnvService,
    private router: Router,
    public route: ActivatedRoute,
    private titleService: Title,
    private authService: AuthService
  ) {
    this.loggedInUser = this.authService.loggedInUser
    this.onSelect('quantity')
  }

  ngOnInit() {
    let current = this.route
    while (current.firstChild) {
      current = current.firstChild
    }
    this.tab = current.snapshot.routeConfig?.path
    this.headerStyleService.setHeaderClass(null)
  }

  onSelect($event: string) {
    this.titleService.setTitle(_.startCase(_.camelCase($event)) + ' | Admin | Scope')
    this.router.navigate([$event], { relativeTo: this.route })
    this.baseJsUrl = `${this.envService.baseJsUrl}/dashboard/${$event}?host=${environment.baseHost}&childCompany=${this.authService.loggedInUser?.company.id}`
  }
}
